module.exports = __webpack_public_path__ + "static/media/jobbeurs_home2_resize.2617d024.jpg";